export default "__VITE_ASSET__Cig9Cidl__"